import { t } from "i18next";
import { Button, Form, Modal } from "react-bootstrap";
import { createSeason } from "../../../../services/season";
import { Media } from "../../../../interfaces/media";
import { useState } from "react";
import Uploader from "../../../general/uploader";

interface AdminSeasonNewProps {
    onSave: CallableFunction;
    onClose: CallableFunction;
}

export function AdminSeasonNew(props: AdminSeasonNewProps) {
    const [media, setMedia] = useState<Media[]>([]);

    const handleSave = (event: any) => {
        event.preventDefault();

        const body = {
            name: event.target.name.value,
            date_start: event.target.date_start.value,
            date_end: event.target.date_end.value
        }
        createSeason(body)
            .then(response => {
                if (response.data.status == 1) {
                    props.onSave(response.data.data);
                } else {
                    alert(response.data.message);
                }
            })
            .catch(error => {
                console.log(error);
            });
    }
    
    const handleClose = () => {
        props.onClose();
    }
    
    return (
        <Modal className="admin-season-new-container" show={ true }
            onHide={ handleClose }> 
            <Modal.Header closeButton>
                <Modal.Title>
                    { t("new_season") }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={ handleSave }>
                    <div className="fields">
                        <Form.Group className="mb-3" controlId="name">
                            <Form.Label aria-required="true">{ t("Name") }</Form.Label>
                            <Form.Control type="text" name="name" required />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="date_start">
                            <Form.Label aria-required="true">{ t("Start date") }</Form.Label>
                            <Form.Control type="date" name="date_start" required />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="date_end">
                            <Form.Label aria-required="true">{ t("End date") }</Form.Label>
                            <Form.Control type="date" name="date_end" required />
                        </Form.Group>
                    </div>
                    <div className="actions">
                        <Button type="submit" variant="primary">
                            { t("Save") }
                        </Button>
                        <Button variant="secondary" onClick={ handleClose }>
                            { t("Close") }
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
}